export type RejectionErrorCode = 'rejected' | 'banned' | 'ipBlocked' | 'circumventionWarning'

export function getRejectionMessage(code: RejectionErrorCode, daysRemaining?: number): string {
  switch (code) {
    case 'rejected':
      if (daysRemaining) {
        return `You were previously turned away from Revel Club. You can reapply in ${formatDays(daysRemaining)}.`
      }
      return 'You were previously turned away from Revel Club. Please contact support for more information.'

    case 'banned':
      if (daysRemaining) {
        return `You are banned from Revel Club. You may reapply in ${formatDays(daysRemaining)}.`
      }
      return 'You are permanently banned from Revel Club.'

    case 'ipBlocked':
      return 'Access from this location is not permitted. Please contact support if you believe this is an error.'

    case 'circumventionWarning':
      if (daysRemaining) {
        return `You were previously turned away from Revel Club. You can reapply in ${formatDays(daysRemaining)}. Attempting to circumvent this by using a different email may result in a permanent ban.`
      }
      return 'You were previously turned away from Revel Club. Your waiting period has expired, but you must use your original email address to reapply.'

    default:
      return 'Access denied. Please contact support.'
  }
}

function formatDays(days: number): string {
  if (days < 30) {
    return days === 1 ? '1 day' : `${days} days`
  }

  const months = Math.floor(days / 30)
  if (months < 12) {
    return months === 1 ? '1 month' : `${months} months`
  }

  const years = Math.floor(months / 12)
  const remainingMonths = months % 12

  if (remainingMonths > 0) {
    return `${years} years and ${remainingMonths} months`
  }

  return years === 1 ? '1 year' : `${years} years`
}
